import Futvolei from "../icons/futvolei.svg";
import Volei from "../icons/volei.svg";
import BeachTennis from "../icons/beachTennis.svg";
import Soccer from "../icons/soccer.png";

export const clientRoutes = ["/", "reservas", "horarios"];

export const modalitiesConstant = [
  "Beach Tennis",
  "Futvôlei",
  "Vôlei",
  "Futebol",
  "Tennis",
];

export const daysOfWeek = [
  "Domingo",
  "Segunda Feira",
  "Terça Feira",
  "Quarta Feira",
  "Quinta Feira",
  "Sexta Feira",
  "Sábado",
];

export const MODALITIES_MAP: Record<number, { label: string; icon: any }> = {
  0: { label: "Beach Tennis", icon: BeachTennis },
  1: { label: "Futvôlei", icon: Futvolei },
  2: { label: "Vôlei", icon: Volei },
  3: { label: "Futebol", icon: Soccer },
  4: { label: "Tênis", icon: BeachTennis },
};
